module.exports = __webpack_public_path__ + "img/2.4f531f41.png";